import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ProjectCollection } from 'app/modules/project/models/project-collection.model';
import { FieldStatistics, FieldStatisticsPayload } from 'app/providers/field-statistics.service';
import { CalculationRequest } from 'app/providers/storage-api/predictive.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { FieldService } from '../../../../../providers/storage-api/field.service';
import { DriverAnalysisStep } from './../driver-analysis-dialog.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-analysis-target-step',
  templateUrl: './analysis-target-step.component.html',
  styleUrls: ['./analysis-target-step.component.scss'],
  standalone: false,
})
export class AnalysisTargetStepComponent implements DriverAnalysisStep, OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() data: Partial<CalculationRequest>;
  @Input() collection: ProjectCollection;
  @Input() fieldStatisticsPayload: FieldStatisticsPayload;

  @Output() onValidityChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  availableTargetFields: { label: string; value: string }[] = [];
  fieldStatistics: { [field: string]: FieldStatistics };
  isLoading = true;

  constructor() {}

  ngOnInit() {
    this.onValidityChange.emit(!!this.data.dependentColumn);

    this.fieldStatistics = this.fieldStatisticsPayload.custom;

    this.availableTargetFields = Object.keys(this.fieldStatistics)
      .filter((fieldName) => FieldService.isRating(fieldName) && FieldService.isVisible(fieldName))
      .map((fieldName) => ({ label: this.getLongLabel(fieldName), value: fieldName }))
      .sort((a, b) => a.label.localeCompare(b.label));

    this.isLoading = false;
  }

  getLongLabel(s: string): string {
    return FieldService.getFieldLongName(s);
  }
}
